import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { ColorType } from '../../../editor/features/beta/styles/colorsByType';
import { Tooltip } from '@mm/components';

type Props = {
  message: string | ReactNode;
  customIcon?: ReactNode;
  classNameContainer?: string;
  classNameContent?: string;
  classNamePopoverContainer?: string;
  classNameAnchor?: string;
  classNameIconAnchor?: string;
  align?: 'center' | 'start' | 'end';
  position?: 'top' | 'bottom';
  type?: ColorType;
  hoverMode?: boolean;
};

export const TooltipContainer = (props: Props) => (
  <Tooltip
    isWhite
    title={<div>{props.message}</div>}
    placement={props.position}
  >
    <span
      className={classnames(
        'tooltips-container__anchor',
        props.classNameAnchor,
      )}
    >
      {props.customIcon}
      {!props.customIcon && (
        <i
          className={classnames(
            'far',
            props.classNameIconAnchor || 'fa-question-circle',
          )}
        />
      )}
    </span>
  </Tooltip>
);
